import { useState, useEffect, useRef } from "react";
import { API } from "../backend";
import axios from "axios";
import authHeader from "../services/auth-header";
import ButtonLoading from '../components/Loder/buttonLoading'
import FullscreenIcon from '@material-ui/icons/Fullscreen';

function Basic() {
  const [chatboxVisible, setChatboxVisible] = useState(false);
  const [chatLog, setChatLog] = useState([]);
  const [userInput, setUserInput] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  // Default to true so legacy users/initial load don't see a gray icon
  const [chatbotEnabled, setChatbotEnabled] = useState(true);
  const [loadingFeatures, setLoadingFeatures] = useState(true);

  const containerRef = useRef(null);

  // Fetch subscription and check if chatbot is enabled
  useEffect(() => {
    const fetchChatbotAccess = async () => {
      try {
        setLoadingFeatures(true);
        const response = await axios.get(`${API}paymentsub/subscription/`, {
          headers: authHeader()
        });

        if (response.data.success === 1 && response.data.data) {
          const plan = response.data.data.plan;
          // OPT-OUT LOGIC: Only disable if the plan specifically says FALSE.
          // Old subscriptions with missing fields or null will remain TRUE.
          if (plan && plan.ask_athena_ai === false) {
            setChatbotEnabled(false);
          } else {
            setChatbotEnabled(true);
          }
        }
      } catch (error) {
        console.error('Error fetching chatbot access:', error);
        setChatbotEnabled(true); // Fallback to enabled on error
      } finally {
        setLoadingFeatures(false);
      }
    };
    fetchChatbotAccess();
  }, []);

  const toggleChatbox = (message) => {
    // If disabled, clicking does nothing (no alert, no UI)
    if (!chatbotEnabled) return;
    
    setChatLog([])
    message = ''
    sendMessageToRasa(message)
    setChatboxVisible(!chatboxVisible);
  };

  // ... (displayUserMessage, displayBotMessage, sendMessageToRasa, etc. remain unchanged)

  const displayUserMessage = (message) => {
    const userMessage = { sender: 'user', text: message };
    setChatLog(prevChatLog => [...prevChatLog, userMessage]);
  };

  const displayBotMessage = (message, buttons) => {
    try {
      const botMessage = { sender: 'bot_reply', text: message, button: buttons };
      setChatLog(prevChatLog => [...prevChatLog, botMessage]);
      if (message.sender !== 'user') {
        setIsLoading(false);
      }
    } catch (e) {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (containerRef && containerRef.current) {
      const element = containerRef.current;
      element.scroll({
        top: element.scrollHeight,
        left: 0,
        behavior: "smooth"
      })
    }
  }, [containerRef, chatLog])

  const sendMessageToRasa = async (message) => {
    try {
      setIsLoading(true)
      const config = {
        headers: { 'content-type': 'multipart/form-data' }
      }
      const response = await axios.post(`${API}chat/chat_with_bot/`,
        {
          user_message: message
        },
        config,
      )
      const data = await response.data;
      if (data.bot_reply) {
        setIsLoading(false);
        displayBotMessage(data.bot_reply, data.choice);
      }
      return data;
    } catch (error) {
      setIsLoading(false);
      console.error('Error sending message to chatbot:', error);
    }
  };

  const handleButtonPayload = (payload) => {
    sendMessageToRasa(payload);
  };

  const handleSendMessage = (event) => {
    if (event.keyCode === 13) {
      const message = userInput.trim();
      if (message !== "") {
        displayUserMessage(message);
        sendMessageToRasa(message);
        setUserInput("");
      }
    }
  };

  const handleScreen = () => {
    const chatbox = document.querySelector('.chatbox');
    if (!document.fullscreenElement) {
      if (chatbox.requestFullscreen) chatbox.requestFullscreen();
    } else {
      if (document.exitFullscreen) document.exitFullscreen();
    }
  }

  if (loadingFeatures) return null;

  return (
    <div>
      <div className="container containerm">
        <div 
          className="chat-icon" 
          onClick={toggleChatbox}
          style={{ 
            cursor: chatbotEnabled ? 'pointer' : 'not-allowed',
          }}
        >
          <img 
            src="/static/assets/img/curved-images/Ask_Athena_Icon-removebg-previews.png" 
            alt="Ask Athena" 
            style={{ 
              width: '100%', 
              height: '100%', 
              // Apply grayscale and lower opacity if disabled
              filter: chatbotEnabled ? 'none' : 'grayscale(100%)',
              opacity: chatbotEnabled ? 1 : 0.6
            }} 
          />
        </div>

        {/* Only allow chatbox to show if enabled */}
        {chatboxVisible && chatbotEnabled && (
          <div className="chatbox">
            <div className="chatbox-header">
              Ask Athena
              <span className="fullscreen-icon cursor-pointer"
                style={{ position: 'absolute', right: '35px', top: '15px' }}
                onClick={handleScreen}>
                <i><FullscreenIcon /></i>
              </span>
              <span className="close-icon cursor-pointer" onClick={toggleChatbox}>
                <i className="fa fa-times"></i>
              </span>
            </div>
            <div className="chatbox-body" ref={containerRef} style={{ overflowY: 'auto', flex: 1 }}>
              {chatLog.map((message, index) => (
                <p key={index} className={`chatbox-message ${message.sender === "user" ? "sent" : "received"}`}>
                  {message.text === undefined ? "" : 
                    <span className="message-content" style={{ fontSize: 'smaller' }}>
                      {message.text.split('\n').map((text, i) => (
                        <span key={i}>{text}<br /></span>
                      ))}
                    </span>
                  }
                  {message.buttons && message.buttons.length > 0 && (
                    <div className="button-container">
                      {message.buttons.map((btn, bIdx) => (
                        <button key={bIdx} onClick={() => handleButtonPayload(btn.payload)}>{btn.title}</button>
                      ))}
                    </div>
                  )}
                </p>
              ))}
              {isLoading && (
                <p className="chatbox-message received message-content" style={{ fontSize: 'smaller' }} >
                  <ButtonLoading color="#808080" size={10} />
                </p>
              )}
            </div>
            <div className="chatbox-controls" style={{ position: 'absolute', bottom: 0, width: '100%' }}>
              <input
                type="text"
                className="chatbox-input"
                placeholder="Type your message..."
                value={userInput}
                onChange={(e) => setUserInput(e.target.value)}
                onKeyDown={handleSendMessage}
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default Basic;